module.exports = __webpack_public_path__ + "static/media/libro.e1033628.svg";